import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import Image from 'components/Image';
import { Card } from 'styles/pages/home/products';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Products = ({ onSelect }) => {
  const categories = useSelector((state) => state?.categories?.data) || [];
  return (
    <div style={{}}>
      <Slider {...settings}>
        {categories.map((category, index) => (
          <div key={`categories${index}`}>
            <Card
              onClick={() =>
                _.isFunction(onSelect) && onSelect(category.CatId)
              }>
              <Image
                aspectRatio={13.5 / 16}
                src={category.MarketingImagePath}
                alt={category.DisplayName}
              />
              <h4>
                <span>Browse</span>&nbsp;{category.DisplayName}
              </h4>
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Products;
